import React from "react";
import CanvasJSReact from "@canvasjs/react-charts";
import { IoClose } from "react-icons/io5";

const CanvasJSChart = CanvasJSReact.CanvasJSChart;

const GraphModal = ({ show, onClose, title, chartOptions }) => {
  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.7)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          backgroundColor: "#2f2f2f",
          borderRadius: 12,
          padding: 20,
          width: "90%",
          maxWidth: "1000px",
          position: "relative",
        }}
      >
        <div
          style={{
            fontSize: 20,
            fontWeight: "bold",
            marginBottom: 20,
            color: "#fff",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {title}
          <IoClose
            size={24}
            style={{ cursor: "pointer", color: "#ccc" }}
            onClick={onClose}
          />
        </div>

        <CanvasJSChart options={chartOptions} />
      </div>
    </div>
  );
};

export default GraphModal;
